export default __webpack_public_path__ + "static/rtsview-09c123b53435bf8e97834a669ea6830f.jpg";